import React, { FC } from "react";

import style from "./style.scss";

export interface AppTotalsProps {
    handlers: number;
    entities: number;
    intents: number;
    faqs: number;
    content: number;
}

export const AppTotals: FC<AppTotalsProps> = (props: AppTotalsProps) => {
    return (
        <div className={style.totals}>
            <div className={style.fullWidth}>
                <dl>
                    <dt>Handlers</dt>
                    <dd>{props.handlers}</dd>
                </dl>
                <dl>
                    <dt>Intents</dt>
                    <dd>{props.intents}</dd>
                </dl>
                <dl>
                    <dt>Entities</dt>
                    <dd>{props.entities}</dd>
                </dl>
                <dl>
                    <dt>Documents</dt>
                    <dd>{props.content}</dd>
                </dl>
                <dl>
                    <dt>FAQs</dt>
                    <dd>{props.faqs}</dd>
                </dl>
            </div>
        </div>
    );
};
